import { QuestionPlanStockTerm as Question } from "@/components/features/items/edit/plan/_shared/ui/components/stock/stock-term";

import { usePlanStockTerm } from "./hooks";

export const QuestionPlanStockTerm = () => {
	const {
		maxStockNum,
		stockTypeTarget,
		stockTypeTerm,
		onSetMaxStockNum,
		onSetStockTypeTarget,
		onSetStockTypeTerm,
		isEdited,
		hasError,
	} = usePlanStockTerm();

	return (
		<Question
			maxStockNum={maxStockNum}
			stockTypeTarget={stockTypeTarget}
			stockTypeTerm={stockTypeTerm}
			onSetMaxStockNum={onSetMaxStockNum}
			onSetStockTypeTarget={onSetStockTypeTarget}
			onSetStockTypeTerm={onSetStockTypeTerm}
			isEdited={isEdited}
			hasError={hasError}
		/>
	);
};
